import Loading from '../views/onboarding/modal.vue';

// prefer centralized logo to ensure consistent branding across modules
const loadingImg = require('@/assets/img/health-think/healththink official  logo.svg');

export default {
  data() {
    return {
      loadingImg,
      loading: false,
      loadingContent: '',
      loadingData: 0,
      loadingTitle: '',
    };
  },
  components: {
    Loading,
  },
  methods: {
    changeLoadingData() {
      for (let i = 1; i < 1; i += 1) {
        setInterval(() => {
          // console.log(i);
          this.loadingData = i;
        }, i * 1000);
      }
    },
  },
  watch: {
    loadingData(newValue) {
      // const firstvisit = localStorage.getItem('visited');
      switch (newValue) {
        case 0:
          this.loadingTitle = '.';
          this.loadingContent = 'Preparing HealthThink';
          break;
        case 1:
          this.loadingTitle = '..';
          this.loadingContent = 'Setting up HealthThink visualizations...';
          break;
        case 2:
          this.loadingTitle = '...';
          this.loadingContent = 'Completed...';
          break;
        case 3:
          this.loadingTitle = '....';
          this.loadingContent = 'Importing metadata, refining charts...';
          break;

        default:
        // code block
      }
    },
  },
  mounted() {
    // const firstvisit = localStorage.getItem('visited');
    this.changeLoadingData();
    this.loadingContent = 'Setting up HealthThink visualizations...';
    this.loadingTitle = '';
  },
};
